// extracted by mini-css-extract-plugin
module.exports = {"form":"form-module--form--3Zxjo","formAlt":"form-module--formAlt--ZGj-O","formInner":"form-module--formInner--3PEy3"};